export const INVOICE = {
  INVOICE_SET_SELECTED: "INVOICE_SET_SELECTED",
  INVOICE_CLEAR_SELECTED: "INVOICE_CLEAR_SELECTED"
};
